<app-page-loader></app-page-loader>
<router-outlet></router-outlet>

<!-- <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>-->
<p-toast position="top-center"></p-toast>
